const runtimeConfig = typeof window !== 'undefined' ? (window.__APP_CONFIG__ ?? {}) : {};
const runtimePlaceholderPattern = /^__([A-Z0-9_]+)__$/;

const readConfig = (key, fallback = '') => {
  const runtimeValue = runtimeConfig[key];
  if (typeof runtimeValue === 'string' && runtimeValue.trim() !== '') {
    return runtimeValue.trim();
  }

  const buildTimeValue = process.env[key];
  if (
    typeof buildTimeValue === 'string' &&
    buildTimeValue.trim() !== '' &&
    !runtimePlaceholderPattern.test(buildTimeValue.trim())
  ) {
    return buildTimeValue.trim();
  }

  return fallback;
};

const appConfig = Object.freeze({
  appEnv: readConfig('REACT_APP_ENVIRONMENT'),
  apiBaseUrl: readConfig('REACT_APP_API_BASE_URL'),
  brandAspName: readConfig('REACT_APP_BRAND_ASP_NAME'),
  brandEmail: readConfig('REACT_APP_BRAND_EMAIL'),
  brandFaviconPath: readConfig('REACT_APP_BRAND_FAVICON_PATH', '/marmin_favicon.ico'),
  brandLogoPath: readConfig('REACT_APP_BRAND_LOGO_PATH', '/marmin_logo.png'),
  brandName: readConfig('REACT_APP_BRAND_NAME', 'OMN E-Invoicing'),
  cookieDomain: readConfig('REACT_APP_COOKIE_DOMAIN') || undefined,
  developerDashboardUrl: readConfig('REACT_APP_DEVELOPER_DASHBOARD_URL'),
  helpAndSupportURl: readConfig('REACT_APP_HELP_AND_SUPPORT_URL', 'https://marminai.atlassian.net/servicedesk/customer/portals'),
  stripeCurrency: readConfig('REACT_APP_STRIPE_CURRENCY', 'AED'),
});

const updateLinkHref = (selector, href) => {
  if (!href) {
    return;
  }

  const linkElement = document.querySelector(selector);
  if (linkElement) {
    linkElement.href = href;
  }
};

export const applyDocumentBranding = () => {
  if (typeof document === 'undefined') {
    return;
  }

  if (appConfig.brandName) {
    document.title = appConfig.brandName;
  }

  updateLinkHref('link[rel="icon"]', appConfig.brandFaviconPath);
  updateLinkHref('link[rel="apple-touch-icon"]', appConfig.brandLogoPath);
};

export default appConfig;
